<template>
  <vs-popup
    :title="'Schedule setups'"
    :active.sync="showThisPopup"
    class="schedule-setups-popup"
    @close="handleClose"
  >
    <div>
      <div
        class="pb-12"
        v-for="setupAndCalendarEntryObject of setupsAndCalendarEntries"
        :key="'div-' + setupAndCalendarEntryObject.setup.id"
      >
        <schedule-setup
          :setup="setupAndCalendarEntryObject.setup"
          :calendar-entry="setupAndCalendarEntryObject.calendarEntry"
          @priority-changed="handlePriorityChanged"
          :disable-component="
            !hasPermissionForActiveVenue(
              'vp.vp.booking.changevenuesetupschedule'
            )
          "
        ></schedule-setup>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import { mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ScheduleSetup from "./components/ScheduleSetup/ScheduleSetup.vue";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";

export default {
  components: {
    flatPickr,
    ScheduleSetup,
  },
  data() {
    const that = this;
    return {
      showThisPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueSetups: "marcom/activeVenueSetups",
      activeVenueSetupCalendarEntries: "marcom/activeVenueSetupCalendarEntries",
    }),
    validForm() {
      return this.campaign_title !== ""; // && this.campaign_description !== "";
    },
    setupsAndCalendarEntries() {
      return !this.showThisPopup
        ? []
        : this.activeVenueSetups
            .map((setup) => {
              let calendarEntry = this.activeVenueSetupCalendarEntries.find(
                (ce) => ce.venueSetupId.id === setup.id
              );

              return {
                setup: setup,
                calendarEntry: calendarEntry,
              };
            })
            .sort((a, b) => {
              const aP = a.calendarEntry ? a.calendarEntry.priority : 0;
              const bP = b.calendarEntry ? b.calendarEntry.priority : 0;
              return bP - aP;
            });
    },
  },
  methods: {
    show() {
      this.showThisPopup = true;
    },
    handleClose() {
      this.showThisPopup = false;
    },
    async handlePriorityChanged({ calendarEntry, direction }) {
      let indexOfCalendarEntry = _.findIndex(
        this.activeVenueSetupCalendarEntries,
        (ce) => ce.id === calendarEntry.id
      );
      let indexOfCalendarEntryToSwap = -1;
      if (direction == "up") {
        if (indexOfCalendarEntry === 0) return; // can't go up
        indexOfCalendarEntryToSwap = indexOfCalendarEntry - 1;
      } else if (direction == "down") {
        if (
          indexOfCalendarEntry ===
          this.activeVenueSetupCalendarEntries.length - 1
        )
          return; // can't go down
        indexOfCalendarEntryToSwap = indexOfCalendarEntry + 1;
      } else {
        return; //wrong direction
      }
      let calendarEntryToSwap =
        this.activeVenueSetupCalendarEntries[indexOfCalendarEntryToSwap];

      try {
        this.$vs.loading();
        var priorityResult = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.SwapCalendarEntries,
          {
            calendarEntry1: calendarEntry.id,
            calendarEntry2: calendarEntryToSwap.id,
          }
        );

        this.$vs.notify({
          color: "success",
          title: "Priorities updated",
          text: "Your calendar table priorities was updated",
        });
      } catch (err) {
        this.$vs.notify({
          color: "danger",
          title: "Priorities not updated",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-setups-popup::v-deep .vs-popup {
  width: 1080px;
}
</style>
